import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'percentage_number_of_normal_workforce'

export const dataPointDefinition = {
  retracedId: 'percentage_number_of_normal_workforce',
  name: 'What percentage of the normal workforce does the Total number of workers reflect?',
  description:
    'Enter a whole number to reflect the percentage. For example your entry of 80 means 80%.\r\r\n\r\r\nThe Total number of workers listed above is the number of workers at the time of self/joint-assessment (Verifier may update this Total number of workers at time of assessment). Does this Total number of workers reflect 100% of the normally active workforce? Or has there been a temporary reduction in workforce due to low season, reduced orders or other circumstance? If the Total number of workers listed above reflects 100% of your normally active workforce enter 100. If it is less, then enter a number between 1 and 100.',
  meta: {
    unit: 'PERCENTAGE',
  },
  fieldTypeId: 'NUMBER_UOM',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fp-wor-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 1050,
  sectionId: '2.2.6.2',
  impactArea: 'Worker Demographics (Languages and Nationalities)',
  impactAreaId: 'WORKER_DEMOGRAPHICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
